import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
// @ts-ignore
import { removeSnackbar as removeSnackbarAction } from 'services/notifications/actions';
// @ts-ignore
import { selectNotifications } from 'services/notifications/selectors';

interface Notification {
    key: string;
    message: string;
    options: Record<string, any>;
    dismissed?: boolean;
}

const Notifier: React.FC = () => {
    const dispatch = useDispatch();
    const notifications: Notification[] = useSelector(selectNotifications);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const displayed: string[] = React.useRef([]).current;

    useEffect(() => {
        notifications.forEach(
            ({ key, message, options = {}, dismissed = false }) => {
                if (dismissed) {
                    closeSnackbar(key);
                    return;
                }
                if (displayed.includes(key)) return;

                enqueueSnackbar(message, {
                    key,
                    ...options,
                    onClose: (event, reason, notificationKey) => {
                        if (options.onClose) {
                            options.onClose(event, reason, notificationKey);
                        }
                    },
                    onExited: (event, notificationKey) => {
                        dispatch(removeSnackbarAction(notificationKey));
                        // Remove the notification from displayed
                        displayed.splice(
                            displayed.indexOf(notificationKey.toString()),
                            1,
                        );
                    },
                });
                // Keep track of snackbars that we've displayed
                displayed.push(key);
            },
        );
    }, [notifications, closeSnackbar, enqueueSnackbar, dispatch, displayed]);

    // Render nothing since this component only handles side effects
    return null;
};

export default Notifier;
